import $ from "jquery";

import { APPLICATION_STATE, REJECTION_REASON } from "lib/constants";

export function patchWithdraw(appID, reason = null) {
    return $.ajax({
        type: "PATCH",
        url: `/api/hire/v1/application/${appID}`,
        contentType: "application/json",
        data: JSON.stringify({
            state: APPLICATION_STATE.REJECTED,
            reason: REJECTION_REASON.WITHDRAWN,
            reason_other: reason,
        }),
    });
}

export default function initWithdraw() {
    const $btn = $("#withdraw-button");

    $btn.on("click touchend", (event) => {
        event.preventDefault();

        const reason = $("#withdraw-reason").val();
        const appID = $btn.data("id");

        if (reason.length < 6) {
            $(".withdraw-label").show();
        } else {
            $btn.loading(true).text("Please wait...");

            patchWithdraw(appID, reason)
                .done(() => {
                    $("#withdraw-main").hide();
                    $("#withdraw-success").show();
                })
                .fail(() => {
                    $("#withdraw-main").hide();
                    $("#withdraw-error").show();
                });
        }
    });
}
